module.exports = __webpack_public_path__ + "static/media/add-file.abe590d6.png";